var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "create-docx-quizzes" }, [
    _c("div", { staticClass: "create-docx-quizzes__body container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              staticClass:
                "create-docx-quizzes__header-title typography--color-primary text-center"
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("publishers.create_docx_quizzes.title")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "create-docx-quizzes__form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "subject-select" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("card_details.card_meta.subject")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.subjectId,
                      expression: "subjectId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "subject-select", disabled: _vm.isSeriesCard },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.subjectId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { disabled: "", value: "" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("card_details.card_meta.subject_placeholder")
                        ) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.subjectIds.filter(function(id) {
                      return id !== "0" && id !== "9999"
                    }),
                    function(sjId) {
                      return _c(
                        "option",
                        { key: sjId, domProps: { value: sjId } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.getTranslatedName(_vm.subjectMap[sjId])
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    }
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "grade-select" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("card_details.card_meta.grade")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.gradeId,
                      expression: "gradeId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "grade-select", disabled: _vm.isSeriesCard },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.gradeId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { disabled: "", value: "" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("card_details.card_meta.grade_placeholder")
                        ) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.gradeIds.filter(function(id) {
                      return id !== "0" && id !== "9999"
                    }),
                    function(gId) {
                      return _c(
                        "option",
                        { key: gId, domProps: { value: gId } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.getTranslatedName(_vm.gradeMap[gId])) +
                              "\n              "
                          )
                        ]
                      )
                    }
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showUnitSelect,
                    expression: "showUnitSelect"
                  }
                ],
                staticClass: "form-group"
              },
              [
                _c(
                  "label",
                  {
                    staticClass:
                      "typography--body-3 typography--color-secondary typography--font-weight-600",
                    attrs: { for: "unit-select" }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("card_details.card_meta.chapter")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.unitId,
                        expression: "unitId"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "unit-select",
                      disabled: _vm.isSeriesCard && _vm.$route.query.unit_id
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.unitId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.onUnitSelect
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { disabled: "", value: "" } }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("card_details.card_meta.chapter_placeholder")
                          ) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.unitList, function(unit) {
                      return _c(
                        "option",
                        { key: unit.id, domProps: { value: unit.id } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(unit.name) +
                              "\n              "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCoreConceptSelect,
                    expression: "showCoreConceptSelect"
                  }
                ],
                staticClass: "form-group"
              },
              [
                _c(
                  "label",
                  {
                    staticClass:
                      "typography--body-3 typography--color-secondary typography--font-weight-600",
                    attrs: { for: "core-concept-select" }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("card_details.card_meta.core_concept")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.coreConceptId,
                        expression: "coreConceptId"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "core-concept-select",
                      disabled:
                        _vm.isSeriesCard && _vm.$route.query.core_concept_id
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.coreConceptId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { disabled: "", value: "" } }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t(
                              "card_details.card_meta.core_concepts_placeholder"
                            )
                          ) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.coreConceptList, function(coreConcept) {
                      return _c(
                        "option",
                        {
                          key: coreConcept.id,
                          domProps: { value: coreConcept.id }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(coreConcept.name) +
                              "\n              "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "video-course-id" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("card_details.card_meta.video_course")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.videoCourseId,
                    expression: "videoCourseId",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "number", id: "video-course-id" },
                domProps: { value: _vm.videoCourseId },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.videoCourseId = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "card-title-input" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("card_details.card_meta.title")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.cardTitle,
                    expression: "cardTitle",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "card-title-input",
                  maxlength: "50",
                  placeholder: _vm.$t(
                    "card_details.card_meta.title_placeholder"
                  )
                },
                domProps: { value: _vm.cardTitle },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.cardTitle = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "card-goal-input" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("card_details.card_meta.goal")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cardGoal,
                    expression: "cardGoal"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  id: "card-goal-input",
                  rows: "5",
                  maxlength: "5000",
                  placeholder: _vm.$t("card_details.card_meta.goal_placeholder")
                },
                domProps: { value: _vm.cardGoal },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.cardGoal = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            !_vm.docxParsingCompleted
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "create-docx-quizzes__upload-area mx-auto text-center"
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "create-docx-quizzes__upload-input text-center clickable w-100"
                        },
                        [
                          _c("input", {
                            ref: "docxFileInput",
                            staticClass: "no-display",
                            attrs: {
                              type: "file",
                              accept: _vm.validFileType,
                              disabled: _vm.loading
                            },
                            on: { change: _vm.onFileInputChange }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "create-docx-quizzes__upload-text typography--headline typography--color-secondary text-center"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("publishers.create_docx_quizzes.upload_text")
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "mt-40 text-center" },
                        [
                          _c("LoadingBounce"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "typography--body-2 typography--color-disabled typography--font-weight-bold pb-5"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.reading_file")) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _c("div", { staticClass: "text-center mt-40" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--content-body typography--color-primary mb-12"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.create_docx_quizzes.file_info.name",
                              { name: _vm.docxFileName }
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-1 typography--color-primary mb-2"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.create_docx_quizzes.file_info.quiz_count",
                              { count: _vm.fileInfo.quizCount }
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-1 typography--color-primary mb-2"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.create_docx_quizzes.file_info.multiple_choice_count",
                              { count: _vm.fileInfo.multipleChoiceCount }
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-1 typography--color-primary mb-2"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.create_docx_quizzes.file_info.text_entry_count",
                              { count: _vm.fileInfo.textEntryCount }
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-1 typography--color-primary mb-2"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.create_docx_quizzes.file_info.image_count",
                              { count: _vm.fileInfo.imageCount }
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center mt-40" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-primary btn-full create-docx-quizzes__create-btn",
                  attrs: { disabled: _vm.createDisabled },
                  on: {
                    click: function($event) {
                      return _vm.create()
                    }
                  }
                },
                [
                  !_vm.busy
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("publishers.create_docx_quizzes.create")
                          )
                        )
                      ])
                    : _c("LoadingBounce")
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-center mt-2" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "btn btn-secondary btn-full create-docx-quizzes__cancel-btn typography--color-secondary",
                    attrs: { to: _vm.prevLink }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("btn.redirect_to_root")) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "docx-type-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.docx_type_alert.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "file-reader-unsupported-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.file_reader_unsupported.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "basic-error-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.basic_error_alert.message")
                )
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "break-word-all mt-3" }, [
              _vm._v("\n        " + _vm._s(_vm.errMsg) + "\n      ")
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25a8b936", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25a8b936","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/views/CreateDocxQuizzes.vue
// module id = vOfy
// module chunks = 1